import {
  VTextField,
  VAutocomplete
} from 'vuetify/components';

import type { FormField } from '@/types/form';

export const CREATE_FORM: FormField[] = [  
    { value: 'client', 
      label: 'Cliente', 
      component: VAutocomplete,
      searchValue: 'name', 
      required: true, 
      col: 6, 
      mdcol:12, 
      fetchOptions: 'searchClients', 
      itemText: (item: any) => item?.attributes?.commercial_name || item?.attributes?.legal_name || '', 
      itemValue: (item: any) => item,
      transform: (value: any) => ({
        client_id: value?.id ?? value,
      }),
    },
    { value: 'name', label: 'Nombre', component: VTextField, required: true, col: 6 },
    { value: 'last', label: 'Apellido', component: VTextField, required: false, col: 6 },
    { value: 'phone', label: 'Teléfono', component: VTextField, required: false, col: 6 },
    { value: 'email', label: 'Email', component: VTextField, required: false, col: 6 },
    { value: 'job_position', label: 'Puesto', component: VTextField, required: false, col: 6 },
];

const idFieldMappings: Record<string, string> = {
    client_id:'client'
};

export const EDIT_FORM: FormField[] = [...CREATE_FORM.map(field => {
  const relatedKey = idFieldMappings[field.value];
  if (relatedKey) {
    return {
      ...field,
      parse: (_: any, item: any) => item[relatedKey] || null,
      transform: (val: any) => ({
        [field.value]: field.multiple
          ? (Array.isArray(val)
              ? val.map(v => v?.[field.itemValue || 'id'] ?? v)
              : [])
          : val?.id ?? val
      })
    };
  }
  return field;
})]

export const HEADERS = [
    { title: 'ID', value: 'id', format: 'text', sortable: false },
    { title: 'Email', value: 'email', format: 'text', sortable: false },
    { title: 'Puesto', value: 'job_position', format: 'text', sortable: false },
    { title: 'Apellido', value: 'last', format: 'text', sortable: false },
    { title: 'Nombre', value: 'name', format: 'text', sortable: true },
    { title: 'Teléfono', value: 'phone', format: 'text', sortable: false },
];

export const DEFAULT_HEADER_ORDER = [
  'id',
  'name',
  'last',
  'phone',
  'email',
  'job_position'
];

export const DETAIL = {
  expand_table: false,
  eye_detail: false,
  key: undefined,
  component: undefined
};

export const ROW_ACTIONS = [
  { label: 'Editar', onClick: '__edit', permission:'clients.update' },
  { label: 'Eliminar', onClick: '__delete', permission:'clients.delete' },
];

export const FILTERS = [
  { value: 'id', label: 'ID', component: VTextField },
  
];